import React from 'react';

import { Box } from '@rbilabs/universal-components';

export const StoreCardSeparator: React.FC = () => {
  return <Box minWidth="1" width="1" maxWidth="1" />;
};
